@if(config?.onconfig){
<div class="btn-group w-100" role="group">
    <button class="btn btn-primary" (click)="config.onconfig()" type="button">
        <i class="far fa-cog"></i> {{ 'configure' | translate}}
    </button>
</div>
}

@if(!config?.onconfig && config?.enabled){
<div class="btn-group w-100" role="group">
    <button type="button" class="btn btn-primary" (click)="enable(config.name)"><i class="far fa-check"></i> {{ 'enabled' | translate}}</button>
    <button type="button" class="btn btn-primary" (click)="test(config.name)"><i class="far fa-play"></i> Test</button>
    @if(config?.name !== 'email-notification'){
    <button type="button" class="btn btn-danger" (click)="remove(config.name)">
        <i class="far fa-trash-alt"></i> {{ 'remove' | translate}}
    </button>
    }
</div>
}

@if(!config?.onconfig && !config?.enabled){
<div class="btn-group w-100" role="group">
    <button type="button" class="btn btn-" (click)="enable(config.name)"><i class="far fa-times"></i> {{ 'disabled' | translate}}</button>
    <button type="button" class="btn btn-primary" disabled=""><i class="far fa-play"></i> Test</button>
    @if(config?.name !== 'email-notification'){
    <button type="button" class="btn btn-danger" (click)="remove(config.name)">
        <i class="far fa-trash-alt"></i> {{ 'remove' | translate}}
    </button>
    }
</div>
}